
import { defineComponent } from 'vue';
import store from '@/store';

export default defineComponent({
  name: 'TrailDescriptionView',
  props: {
    trailid: String,
  },
  async mounted() {
    await store.dispatch('getTrailDescription', this.trailid);
  },
  computed: {
    currentTrail() {
      return store.state.trailinfo;
    },
  },
});
